/* ============================================================================
 * mb-devis.js — Bloc devis des fiches brodeuses (section main-product-mb, trop
 * grosse pour être réécrite par l'API : on agit donc en JS).
 *
 * 1) #mb-devis-form : on remplace le formulaire de contact natif par le
 *    formulaire Tally « Demander un devis » (mK0AdD), en iframe. Mise en page :
 *    intro à gauche, formulaire à droite (700px = largeur Tally), empilé mobile.
 *    PAS de dynamicHeight (sinon bas coupé sans défilement) : hauteur fixe 700px,
 *    l'iframe reste scrollable en interne.
 * 2) Boutons « Demander un devis » ([data-devis-open] + .pv-btn-ghost de la
 *    carte d'achat) : ouvrent le formulaire Tally COURT (VLyL5N) en pop-up.
 *    Le script Tally est préchargé et on attend qu'il soit prêt avant d'ouvrir
 *    -> plus d'ouverture en nouvel onglet.
 * ========================================================================== */
(function () {
  'use strict';

  var TALLY_JS = 'https://tally.so/widgets/embed.js';

  function ensureTallyScript() {
    if (typeof Tally !== 'undefined') return;
    if (document.querySelector('script[src="' + TALLY_JS + '"]')) return;
    var sc = document.createElement('script');
    sc.src = TALLY_JS;
    document.body.appendChild(sc);
  }

  var styled = false;
  function injectStyle() {
    if (styled) return;
    styled = true;
    var css = ''
      /* 2 colonnes : intro à gauche (largeur souple), formulaire à droite calé
         sur 700px (largeur du Tally). Empilé sous 1000px. */
      + '.pp-quote-wrap{grid-template-columns:minmax(0,1fr) minmax(0,700px) !important;gap:48px !important;align-items:start !important;}'
      + '@media(max-width:1000px){.pp-quote-wrap{grid-template-columns:1fr !important;gap:28px !important;max-width:760px !important;margin-left:auto !important;margin-right:auto !important;}}'
      + '.pp-quote-intro p{max-width:none !important;}'
      /* Neutralise la grille 2 colonnes du .pp-quote-form + retire le cadre/padding
         pour que le titre s\'aligne en haut avec le bloc de gauche. */
      + '.pp-quote-form.mbq-form{display:block !important;max-width:none !important;background:transparent !important;border:0 !important;padding:0 !important;}'
      + '.mbq-title{font-family:var(--mb-font-display,"LEMON MILK",sans-serif);text-transform:uppercase;letter-spacing:.02em;color:var(--mb-navy,#1c2646);text-align:center;margin:0;font-size:clamp(20px,2.4vw,28px);}'
      + '.mbq-tally{width:100%;border:0;height:700px;display:block;margin-top:-18px;}';
    var s = document.createElement('style');
    s.textContent = css;
    document.head.appendChild(s);
  }

  function buildDevisForm() {
    var form = document.getElementById('mb-devis-form');
    if (!form) return;
    form.classList.add('mbq-form');
    injectStyle();

    form.innerHTML = '<h2 class="mbq-title">Demande de devis</h2>'
      + '<iframe class="mbq-tally" src="https://tally.so/r/mK0AdD?transparentBackground=1&hideTitle=1" loading="lazy" width="100%" height="700" frameborder="0" marginheight="0" marginwidth="0" scrolling="yes" title="Demander un devis"></iframe>';
  }

  function bindDevisButtons() {
    var SHORT = 'VLyL5N';
    var triggers = [];
    Array.prototype.push.apply(triggers, document.querySelectorAll('[data-devis-open]'));
    Array.prototype.push.apply(triggers, document.querySelectorAll('.pv-buycard-actions .pv-btn-ghost'));
    if (!triggers.length) return;
    ensureTallyScript();    // préchargement pour que la pop-up soit prête au clic

    function openShort(e) {
      if (e) { e.preventDefault(); e.stopImmediatePropagation(); }
      ensureTallyScript();
      var tries = 0;
      (function waitReady() {
        if (typeof Tally !== 'undefined' && Tally.openPopup) {
          Tally.openPopup(SHORT, { layout: 'modal', width: 720, overlay: true, hideTitle: true });
          return;
        }
        if (tries++ > 50) { // ~5 s : dernier recours si le script est bloqué
          window.open('https://tally.so/r/' + SHORT, '_blank', 'noopener');
          return;
        }
        setTimeout(waitReady, 100);
      })();
    }

    triggers.forEach(function (oldBtn) {
      var b = oldBtn.cloneNode(true);
      b.removeAttribute('data-devis-open');
      b.removeAttribute('data-tally-open');
      if (b.tagName === 'A') b.setAttribute('href', 'javascript:void(0)');
      b.style.cursor = 'pointer';
      b.addEventListener('click', openShort, true);
      oldBtn.parentNode.replaceChild(b, oldBtn);
    });
  }

  function init() { buildDevisForm(); bindDevisButtons(); }
  if (document.readyState !== 'loading') { init(); }
  else { document.addEventListener('DOMContentLoaded', init); }
})();
